import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthGuardAccess } from '../enums/auth-guard-access';
import { AuthQueryParamKey } from '../enums/auth-query-param-key';
import { AuthRoute } from '../enums/auth-route';
import { AuthHelper } from '../helpers/auth.helper';
import { AuthService } from '../services/auth.service';
import { AuthStore } from '../stores/auth.store';

export const authGuard = (access: AuthGuardAccess): CanActivateFn => {
  return (_, state) => {
    const store = inject(AuthStore);
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.initialize().pipe(
      map(() => {
        const user = store.user();
        if (!user) {
          if (
            [
              AuthGuardAccess.PUBLIC,
              AuthGuardAccess.PUBLIC_AND_AUTHORIZED,
            ].includes(access)
          ) {
            return true;
          }

          const continueUrl = AuthHelper.getContinueUrl(state.url);
          return router.createUrlTree([AuthRoute.LOGIN], {
            queryParams: continueUrl
              ? { [AuthQueryParamKey.CONTINUE]: continueUrl }
              : null,
          });
        } else if (access === AuthGuardAccess.PUBLIC_AND_AUTHORIZED) {
          authService.logout({ redirect: false });
          return true;
        }

        const business = store.business();
        if (!business) {
          return access === AuthGuardAccess.REGISTER_COMPANY
            ? true
            : router.createUrlTree([AuthRoute.REGISTER_COMPANY]);
        }

        const documents = store.documents();
        // TEMP: Wait for BE documents status fix
        // if (documents?.status !== BusinessDocumentsStatus.VERIFIED) {
        if (documents == null) {
          return access === AuthGuardAccess.REGISTER_DOCUMENTS
            ? true
            : router.createUrlTree([AuthRoute.REGISTER_DOCUMENTS]);
        }

        return true;
      }),
    );
  };
};
